import type { GQL_ID } from '@@partner:types:graphql'

import React from 'react'
import { Drawer } from 'rsuite'
import CustomerForm from './CustomerForm'

export interface CustomerEditDrawerProps {
  isOpen: boolean
  customerId?: GQL_ID
  onClose: () => void
  onSaved?: (customerId: GQL_ID) => void
}

export default function CustomerEditDrawer ({
  isOpen,
  customerId,
  onClose,
  onSaved
}: CustomerEditDrawerProps) {
  const handleSaved = (id: GQL_ID) => {
    onSaved?.(id)
    onClose()
  }

  return (
    <Drawer size="sm" placement="right" open={isOpen} onClose={onClose}>
      <Drawer.Header>
        <Drawer.Title>
          {customerId ? `Редактирование клиента #${customerId}` : 'Новый клиент'}
        </Drawer.Title>
      </Drawer.Header>

      <Drawer.Body>
        <CustomerForm 
          customerId={customerId} 
          onSaved={handleSaved}
        />
      </Drawer.Body>
    </Drawer>
  )
}
